import { DOMReady } from "../../utilities/dom";

const cache = {};

/**
 * Fetches global 'adi-account' custom element encapsulating all pertinent auth logic
 * @returns {HTMLElement}
 */
export const getAccount = () => {
    const account = cache.account ?? document.querySelector( 'adi-account' );
    if ( !cache.account && account ) cache.account = account;
    return account;
};

/**
 * Key name of 'my' auth token
 * @type {string}
 */
export const TOKEN_MY = 'my';

/**
 * Retrieves the latest auth token from the adi-account custom element
 * @returns {string} Latest auth token
 */
export const getAuthToken = () => getAccount()?.tokens?.[ TOKEN_MY ]?.token ?? null;
